/*
  Volume Discount – Injector (Fremd-Endpoints ohne Theme-Formulare)

  Wird geladen auf (siehe theme.liquid):
  - page.swym (Swym-Wishlist)
  - /apps/suche/* (OpenSearch-Suchergebnisse)

  Diese Seiten rendern Add-to-Cart client-seitig und senden Requests ohne
  das _vd_tiers-Property, das die Shopify Function für den Staffelrabatt braucht.

  Vorgehen (nachgelagert statt Request-Manipulation, da die Tiers-Daten zum
  Request-Zeitpunkt client-seitig nicht vorliegen):
  1. Beobachte erfolgreiche /cart/add-, /cart/change- und /cart/update-Requests
     (fetch + XHR).
  2. Lies danach /cart.js und finde Zeilen ohne _vd_tiers.
  3. Schlage die Tiers pro Produkt serverseitig frisch nach:
     /products/<handle>?view=vd-tiers (templates/product.vd-tiers.liquid).
  4. Trage das Property per /cart/change.js (Line-Key) nach. Der Wert ist der
     vollständige Tiers-String – identisch für jede Zeile derselben Variante,
     damit Shopify Cart-Lines korrekt merged.
*/
(function () {
  'use strict';

  if (window._vdInjectorLoaded) return;
  window._vdInjectorLoaded = true;

  var tiersMapCache = {};

  function getTiersMapForHandle(handle) {
    if (tiersMapCache[handle]) return Promise.resolve(tiersMapCache[handle]);
    try {
      var stored = sessionStorage.getItem('vd_tiers_' + handle);
      if (stored) {
        tiersMapCache[handle] = JSON.parse(stored);
        return Promise.resolve(tiersMapCache[handle]);
      }
    } catch (e) {}
    return fetch('/products/' + handle + '?view=vd-tiers')
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var map = JSON.parse(text);
        tiersMapCache[handle] = map;
        try { sessionStorage.setItem('vd_tiers_' + handle, JSON.stringify(map)); } catch (e) {}
        return map;
      })
      .catch(function () { return {}; });
  }

  var patching = false;

  function ensureCartTiers() {
    if (patching) return;
    patching = true;

    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var linesWithoutTiers = (cart.items || []).filter(function (item) {
          return !(item.properties && item.properties['_vd_tiers']);
        });

        // sequenziell patchen, um Race Conditions mit wechselnden Line-Keys zu vermeiden
        return linesWithoutTiers.reduce(function (chain, item) {
          return chain.then(function (didPatch) {
            return getTiersMapForHandle(item.handle).then(function (map) {
              var tiers = map[String(item.variant_id)];
              if (!tiers) return didPatch;
              var properties = Object.assign({}, item.properties, { '_vd_tiers': tiers });
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: item.key,
                  quantity: item.quantity,
                  properties: properties
                })
              }).then(function () { return true; }).catch(function () { return didPatch; });
            });
          });
        }, Promise.resolve(false));
      })
      .then(function (didPatch) {
        patching = false;
        if (didPatch && typeof window.refreshCart === 'function') {
          window.refreshCart();
        }
      })
      .catch(function () {
        patching = false;
      });
  }

  function scheduleEnsure() {
    // kurz warten, bis Shopify die Cart-Änderung persistiert hat
    setTimeout(ensureCartTiers, 300);
    // zweiter Durchlauf als Sicherheitsnetz (z.B. wenn die App mehrere Requests feuert)
    setTimeout(ensureCartTiers, 1500);
  }

  function isCartMutationUrl(url) {
    if (typeof url !== 'string') url = String(url);
    return url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1;
  }

  function setupObservers() {
    var originalFetch = window.fetch;
    window.fetch = function (url, options) {
      var urlStr = typeof url === 'string' ? url : url.toString();
      var result = originalFetch.call(this, url, options);
      if (isCartMutationUrl(urlStr)) {
        result.then(function (response) {
          if (response && response.ok) scheduleEnsure();
        }).catch(function () {});
      }
      return result;
    };

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._vdUrl = url;
      this._vdMethod = method;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (
        this._vdMethod &&
        this._vdMethod.toUpperCase() === 'POST' &&
        this._vdUrl &&
        isCartMutationUrl(this._vdUrl)
      ) {
        this.addEventListener('load', function () {
          if (this.status < 400) scheduleEnsure();
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  function init() {
    setupObservers();
    // Initialer Durchlauf: repariert Zeilen, die auf anderen Wegen ohne
    // Property in den Warenkorb gelangt sind.
    ensureCartTiers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
